const pad = (value: number, width = 2): string =>
  String(value).padStart(width, '0');

export const formatTimestamp = (seconds: number): string => {
  const totalMs = Math.max(0, Math.floor(seconds * 1000));
  const ms = totalMs % 1000;
  const totalSeconds = Math.floor(totalMs / 1000);
  const s = totalSeconds % 60;
  const m = Math.floor(totalSeconds / 60) % 60;
  const h = Math.floor(totalSeconds / 3600);

  return `${pad(h)}:${pad(m)}:${pad(s)}.${pad(ms, 3)}`;
};
